module.exports = __webpack_public_path__ + "static/img/UOOYAA_07_53.86d6f1b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/issue11/04/UOOYAA_07_53.jpg
// module id = BwZB
// module chunks = 7